import jQuery from 'jquery';

; (function ($, window, document, undefined) {

	// Autocomplete plugin
	/* Expected markup (with default selectors):
		<div class="js-autocomplete">
			<input type="text" class="js-autocomplete-input" />
			<ul class="js-autocomplete-list"></ul>
		</div>

		Example usages:

		Remote source:
		$('.js-autocomplete').autocomplete({
			source: '/Ajax/Autocomplete?query=',
			mapToDisplayText: function (a) {
				return a.DisplayText;
			},
			clickCallback: function ($option, obj) {
				console.log($option, obj);
			},
			hideOnBlur: false,
			onLoad: true
		})

		Local source as an array of objects:
		$('.js-autocomplete').autocomplete({
			source: [
				{
					name: 'test 1'
				},
				{
					name: 'test 2'
				}
			],
			mapToFilteredValue: function (a) {
				return a.name;
			},
			mapToDisplayText: function (a) {
				return a.name;
			}
		});
	 */

	var pluginName = 'autocomplete';
	var	defaults = {
		// Time (ms) to throttle keyup events
		throttleTimeout: 1000,
		// Maximum number of autocomplete results to show. Set to 0 or negative to have no maximum
		numAutocompleteItems: 10,

		// Source of autocomplete results. Can come in the following formats (in order of precedence)
		// String: AJAX Url to get autocomplete results. To be appended with the query. Should return array of strings or objects
		// Array: An array of strings or objects equivalent to what could be returned from an AJAX Url
		// Empty/Falsy: If nothing is passed in here, the plugin will look for a data-autocomplete-url attribute on the input
		source: '',
		// A default value to appear at the bottom of the list. Ignored if falsy
		default: null,

		// Function to map array returned from url into display strings, if necessary
		mapToDisplayText: function (a) {return a;},
		// Function to call when Autocomplete result is clicked. Passes in jQuery object of clicked option and relevant element from array returned from url
		clickCallback: function ($option, obj) {
			// This object is bound to the wrapper element
		},

		// Function to map object in source array to string, used for filtering against string query. Used if source is local
		mapToFilteredValue: function (a) {
			return a;
		},

		// Class to apply while waiting for AJAX to complete
		loadingClass: 'is-loading',
		// Class to apply when results are displayed
		activeClass: 'is-autocomplete',

		inputSelector: '.js-autocomplete-input',
		listSelector: '.js-autocomplete-list',
		itemSelector: '.js-autocomplete-list-item',
		defaultSelector: '.js-autocomplete-default-item',

		// Set to true to update value of input when autocomplete option is selected
		updateInput: true,
		// Set to true to hide autocomplete options when an option is selected
		hideOnSelect: false,
		// Set to true to hide autocomplete options when input is blurred
		hideOnBlur: true,
		// Set to true to show results when plugin is initialised
		onLoad: false,
		// Set to true to show all results when query is blank. Used only for local source
		showAllByDefault: false,
		// Set to true to show all results when the input gains focus. Used only for local source
		showAllOnFocus: false,
		// Set to true to allow up and down arrow keys to select results
		selectWithArrowKeys: true,
		// Set to true to trigger autocomplete when "Enter" key is pressed
		triggerOnEnter: false
	};

	// The actual plugin constructor
	function Plugin(element, options) {

		var $lastItem;
		var index;

		//Instance variables
		this.element = element;
		this.$element = $(this.element);
		this.options = $.extend({}, defaults, options);
		this._defaults = defaults;
		this._name = pluginName;

		this.$list = this.$element.find(this.options.listSelector);
		this.$input = this.$element.find(this.options.inputSelector);
		this.source = this.options.source || this.$input.data('autocomplete-url');

		this.text = this.$input.val();
		this.initEvents();

		if (this.options.onLoad) {
			this.getList();
		}
	}

	Plugin.prototype.initEvents = function () {
		var Autocomplete = this;

		Autocomplete.$element
			.on('keyup', Autocomplete.options.inputSelector, Autocomplete.processKeyUp.bind(Autocomplete))
			.on('focus change', Autocomplete.options.inputSelector, Autocomplete.processFocus.bind(Autocomplete))
			.on('mousedown', Autocomplete.options.itemSelector, Autocomplete.processClick.bind(Autocomplete));

		if (Autocomplete.options.selectWithArrowKeys) {
			Autocomplete.$element.on('keydown', Autocomplete.options.inputSelector + ', ' + Autocomplete.options.itemSelector, Autocomplete.changeActiveSelection.bind(Autocomplete));
		}

		if (Autocomplete.options.hideOnBlur) {
			Autocomplete.$element.on('blur', Autocomplete.options.inputSelector + ', ' + Autocomplete.options.itemSelector, Autocomplete.processBlur.bind(Autocomplete));
		}

		Autocomplete.$element.on('autocomplete/hide', Autocomplete.hideAutocomplete.bind(Autocomplete));
	};

	Plugin.prototype.processKeyUp = function (e) {
		var Autocomplete = this,

			$input = Autocomplete.$input;

		if (Autocomplete.options.triggerOnEnter && e.which === 13) { // Enter
			if (Autocomplete.keyupTimer) {
				window.clearTimeout(Autocomplete.keyupTimer);
			}
			Autocomplete.getList();

			return;
		}

		if (Autocomplete.text !== $input.val()) {
			Autocomplete.text = $input.val();
			if (Autocomplete.keyupTimer) {
				window.clearTimeout(Autocomplete.keyupTimer);
			}
			Autocomplete.keyupTimer = window.setTimeout(function () {
				Autocomplete.getList();
			}, Autocomplete.options.throttleTimeout);
		}
	};

	Plugin.prototype.processFocus = function () {
		var Autocomplete = this,

			$input = Autocomplete.$input;

		if (Autocomplete.options.showAllOnFocus) {
			Autocomplete.getList('');
		} else if (Autocomplete.options.showAllByDefault || Autocomplete.text !== $input.val()) {
			Autocomplete.text = $input.val();
			Autocomplete.getList();
		} else {
			Autocomplete.showAutocomplete();
		}
	};

	Plugin.prototype.processBlur = function () {
		var Autocomplete = this,

			$items, $focus;

		// 1 ms timeout so we can check what element has gained focus
		window.setTimeout(function () {
			$items = Autocomplete.$input.add(Autocomplete.$list.find(Autocomplete.options.itemSelector));
			$focus = $(document.activeElement);

			if ($items.index($focus) === -1) {
				Autocomplete.hideAutocomplete();
			}
		}, 1);
	};

	Plugin.prototype.processClick = function (e) {
		var Autocomplete = this,

			$items = Autocomplete.$list.find(Autocomplete.options.itemSelector + ':not(' + Autocomplete.options.defaultSelector + ')'),
			$option = $(e.target).closest(Autocomplete.options.itemSelector),
			$input = Autocomplete.$input,

			callbackObj;

		if (Autocomplete.options.updateInput) {
			$input.val($option.text());
		}


		if ($items.index($option.closest($items)) in Autocomplete.list) {
			callbackObj = Autocomplete.list[$items.index($option.closest($items))];
		} else {
			callbackObj = Autocomplete.options.default;
		}

		Autocomplete.options.clickCallback.call(Autocomplete.$element, $option, callbackObj);

		if (Autocomplete.options.hideOnSelect) {
			Autocomplete.hideAutocomplete();
		}
	};

	Plugin.prototype.getList = function (query) {
		var Autocomplete = this,

			$input = Autocomplete.$input,
			source,

			onLoadResults = function (results, status) {
				var data = [];

				// Create deep copy for safe manipulation
				$.extend(true, data, results);

				Autocomplete.$element.removeClass(Autocomplete.options.loadingClass);

				if (Autocomplete.options.numAutocompleteItems > 0) {
					Autocomplete.list = data.splice(0, Autocomplete.options.numAutocompleteItems);
				} else {
					Autocomplete.list = data;
				}

				Autocomplete.list = Autocomplete.filterList(Autocomplete.list, query);
				Autocomplete.updateAutocompleteList($input, query);
				Autocomplete.showAutocomplete();
			};

		if (typeof query === 'undefined') {
			query = $input.val();
		}

		if (!Autocomplete.options.showAllByDefault && !query) {
			Autocomplete.hideAutocomplete();
			return;
		}

		Autocomplete.$element.addClass(Autocomplete.options.loadingClass);

		if (Autocomplete.source instanceof String) {
			// Remote source
			$.ajax({
				source: Autocomplete.source + encodeURIComponent(query),
				success: onLoadResults
			});
		} else {
			// Local source
			source = Autocomplete.source;

			if (query) {
				source = source.filter(function (value, i, arr) {
					value = Autocomplete.options.mapToDisplayText(value).toLowerCase();

					return value.indexOf(query.toLowerCase()) !== -1;
				});

				// Sort by relevance, i.e. how early the query matches in the value
				source = source.sort(function (a, b) {
					a = Autocomplete.options.mapToDisplayText(a).toLowerCase();
					b = Autocomplete.options.mapToDisplayText(b).toLowerCase();

					return a.indexOf(query.toLowerCase()) - b.indexOf(query.toLowerCase());
				});
			}

			onLoadResults(source);
		}
	};

	Plugin.prototype.changeActiveSelection = function (e) {
		var Autocomplete = this,

			$items,
			$focus = $(document.activeElement),
			index, newIndex;

		$items = Autocomplete.$input.add(Autocomplete.$list.find(Autocomplete.options.itemSelector));
		index = $items.index($focus);

		switch (e.which) {
		case 40:
			// Down
			e.preventDefault();

			if ($focus.closest(Autocomplete.$list).length) {
				newIndex = (index + 1) % $items.length;
			} else {
				newIndex = 1;
			}
			break;
		case 38:
			// Up
			e.preventDefault();

			if ($focus.closest(Autocomplete.$list).length) {
				newIndex = (index - 1 + $items.length) % $items.length;
			} else {
				newIndex = $items.length - 1;
			}
			break;
		case 13:
			// Enter
			$focus.trigger('mousedown');

			break;
		default:
			break;
		}

		$items.eq(newIndex).focus();
	};

	Plugin.prototype.hideAutocomplete = function () {
		var Autocomplete = this;

		if (Autocomplete.keyupTimer) {
			window.clearTimeout(Autocomplete.keyupTimer);
		}
		Autocomplete.$element.removeClass(Autocomplete.options.activeClass);
		$(document).trigger('scroll');
	};

	Plugin.prototype.showAutocomplete = function () {
		var Autocomplete = this;

		if (Autocomplete.$list.find(Autocomplete.options.itemSelector).length) {
			Autocomplete.$element.addClass(Autocomplete.options.activeClass);
		}
		$(document).trigger('scroll');
	};

	Plugin.prototype.updateAutocompleteList = function ($el, list, q) {
		var Autocomplete = this,

			$list = Autocomplete.$list,
			i;

		if (!$list.length) {
			$list = Autocomplete.$list = $('<ul class="' + Autocomplete.options.listSelector + ' autocomplete__list">');
			$list.insertAfter($el);
		}

		$list.html('');

		if (Autocomplete.options.default) {
			$list.append($(
				'<li class="autocomplete__list-item autocomplete__list-item--default">' +
				// tabindex="-1" lets JavaScript set focus to this element
				'<a class="' + (Autocomplete.options.itemSelector).substring(1) + ' ' + (Autocomplete.options.defaultSelector).substring(1) + ' autocomplete__list-link" tabindex="-1">' +
				Autocomplete.options.mapToDisplayText(Autocomplete.options.default) +
				'</a>' +
				'</li>'
			));
		}

		for (i = 0; i < Autocomplete.list.length; i++) {
			$list.append($(
				'<li class="autocomplete__list-item">' +
				// tabindex="-1" lets JavaScript set focus to this element
				'<a class="' + (Autocomplete.options.itemSelector).substring(1) + ' autocomplete__list-link" tabindex="-1">' +
				Autocomplete.options.mapToDisplayText(Autocomplete.list[i]) +
				'</a>' +
				'</li>'
			));
		}
	};

	Plugin.prototype.filterList = function (list, query) {
		var Autocomplete = this,

			filteredList = [],
			i;

		for (i = 0; i < list.length; i++) {
			if (Autocomplete.options.mapToDisplayText(list[i]).toLowerCase().indexOf(query.toLowerCase()) !== -1) {
				filteredList.push(list[i]);
			}
		}

		filteredList.sort(Autocomplete.byRelevance(Autocomplete, query));

		return filteredList;
	};

	Plugin.prototype.byRelevance = function (Autocomplete, query) {
		query = query.toLowerCase();
		return function (a, b) {
			a = Autocomplete.options.mapToDisplayText(a).toLowerCase();
			b = Autocomplete.options.mapToDisplayText(b).toLowerCase();
			return ((a.indexOf(query) + 1) || 1000) - ((b.indexOf(query) + 1) || 1000);
		};
	};

	$.fn[pluginName] = function(options) {

		if(options === 'destroy') {
			var plugin = $(this).data('plugin_' + pluginName);
			if(!plugin) {
				return;
			}
			plugin.destroy();
			return;
		}

		return this.each(function() {
			if (!$.data(this, 'plugin_' + pluginName)) {
				$.data(this, 'plugin_' + pluginName,
					new Plugin(this, options));
			}
		});
	};

})(jQuery, window, document);